export const formErrors = {
  REQUIRED: "זהו שדה חובה",
  INVALID_EMAIL: "אימייל שגוי",
};
